export default {
    path : "enterprise-all",
    name : "enterprise-all",
    meta : {
        title : "全部企业"
    },
    component: () => import('@/components/router/Router'),

    redirect: {
        name : "enterprise-all-whole"
    },
    children:[
        {
            path: '',
            name: '',
            meta: {
                title: ''
            },
            redirect: {
                name : "enterprise-all-whole"
            },
            component: () => import('@/pages/enterprise/all/Index'),
            children: [
                {
                    path: 'all',
                    name: 'enterprise-all-whole',
                    meta: {
                        title: '全部企业-列表页'
                    },
                    component: () => import('@/pages/enterprise/list/Index'),
                },
                {
                    path: 'search',
                    name: 'enterprise-all-search',
                    meta: {
                        title: '全部企业-列表页'
                    },
                    component: () => import('@/pages/enterprise/list/Index'),
                }
            ]
        },
        {
            path: 'enterprise-all-detail/:id',
            name: 'enterprise-all-detail',
            meta: {
                title: '企业详细信息'
            },
            component: () => import('@/pages/enterprise/all/Detail'),
        }
    ]
    
}


// WEBPACK FOOTER //
// ./src/router/enterprise/all_enterprise/index.js